import { makeUrl } from "../utils/urls";
import userStore from "../stores/UserStore";
import { postApi } from "./apiCalls";

export const requestOtp = (phone_number) => {
    return new Promise((resolve, reject) => {
        const url = makeUrl("auth/generate_otp");
        postApi(url, { phone_number })
            .then((data) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const verifyOtp = (phone_number, otp) => {
    return new Promise((resolve, reject) => {
        const url = makeUrl("auth/login");
        postApi(url, { phone_number, otp })
            .then((data) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const logout = () => {
    return new Promise((resolve, reject) => {
        const url = makeUrl("auth/logout");
        postApi(url, {}, "post", true)
            .then((data) => {
                userStore.removeUserToken();
                resolve(data);
            })
            .catch((err) => {
                userStore.removeUserToken();
                reject(err);
            });
    });
};

export const getCustomer = (phone_number) => {
    return new Promise((resolve, reject) => {
        const url = makeUrl("ccm/customers/get-or-create-user");
        postApi(url, { phone_number })
            .then((data) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};
